import {Content} from "pdfmake/interfaces";
import {primaryColor} from "../../../../consts";

export const getSpecificationTableHeader = () => {
    const productTableHeader = [];
    const tableFontSize = 14;
    const header: Content = {
        margin: [20, 25, 20, 10],
        color: primaryColor,
        table: {
            widths: [60, 50, 100, '*', '*'],
            body: [
                [
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Секция',
                        alignment: 'center',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Вид',
                        alignment: 'left',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Размер',
                        alignment: 'left',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Товар',
                        alignment: 'left',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                    {
                        border: [false, false, false, true],
                        borderColor: ['', '', '', primaryColor],
                        text: 'Направляющая',
                        alignment: 'left',
                        fontSize: tableFontSize,
                        bold: false,
                    },
                ]
            ],
        }
    };
    productTableHeader.push(header);
    return productTableHeader
}
